import { render, staticRenderFns } from "./RecommendValueResult.vue?vue&type=template&id=16a19b6f&scoped=true&"
import script from "./RecommendValueResult.vue?vue&type=script&lang=js&"
export * from "./RecommendValueResult.vue?vue&type=script&lang=js&"
import style0 from "./RecommendValueResult.vue?vue&type=style&index=0&id=16a19b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a19b6f",
  null
  
)

export default component.exports